<template>
  <footer class="footer">
    <div class="container">
      <!-- Main Footer Content -->
      <div class="footer-content">
        <!-- Brand Section -->
        <div class="footer-section">
          <div class="footer-logo">
            <img src="https://www-img.sanfu.com/production/logo_light.png" alt="SANFU" class="logo-icon" />
          </div>
          <p class="footer-description">
            {{ $t('footer.brandDescription') }}
          </p>
          <!-- Social Media Links -->
          <div class="social-links">
            <a target="blank" href="https://www.xiaohongshu.com/user/profile/5ab8ad39e8ac2b58e1d6b352" class="social-link" :aria-label="$t('footer.social.xiaohongshu')">
              <img class="social-icon" :alt="$t('footer.social.xiaohongshu')" src="https://www-img.sanfu.com/production/xiaohongshu.png" />
            </a>
            <a target="blank" href="https://weibo.com/u/1738393562" class="social-link" :aria-label="$t('footer.social.weibo')">
              <img class="social-icon" :alt="$t('footer.social.weibo')" src="https://www-img.sanfu.com/production/weibo.png" />
            </a>
            <a target="blank" href="https://www.douyin.com/user/MS4wLjABAAAAsonBW_lf-29tzoop3oodVS3eRWWD863Sl5ErJQ9S_7Q" class="social-link" :aria-label="$t('footer.social.douyin')">
              <img class="social-icon" :alt="$t('footer.social.douyin')" src="https://www-img.sanfu.com/production/douyin.png" />
            </a>
            <a target="blank" href="https://v.kuaishou.com/f/Y7TQR7XG1" class="social-link" :aria-label="$t('footer.social.kuaishou')">
              <img class="social-icon" :alt="$t('footer.social.kuaishou')" src="https://www-img.sanfu.com/production/kuaishou.png" />
            </a>
            <a target="blank" href="http://space.bilibili.com/213697595" class="social-link" :aria-label="$t('footer.social.bilibili')">
              <img class="social-icon" :alt="$t('footer.social.bilibili')" src="https://www-img.sanfu.com/production/bilibili.png" />
            </a>
            <a target="blank" href="https://sffs.tmall.com/" class="social-link" :aria-label="$t('footer.social.tmall')">
              <img class="social-icon" :alt="$t('footer.social.tmall')" src="https://www-img.sanfu.com/production/tmall.png" />
            </a>
            <a target="blank" href="https://m.sanfu.com" :aria-label="$t('footer.social.mall')">
              <div class="social-link">
                <img class="social-icon" :alt="$t('footer.social.mall')" src="https://www-img.sanfu.com/production/logo2.png" style="width: 40px; height: 40px" />
              </div>
            </a>
          </div>
        </div>

        <!-- Quick Links -->
        <!-- <div class="footer-section">
          <h3 class="footer-title">
            {{ $t('footer.quickLinks') }}
          </h3>
          <ul class="footer-links">
            <li>
              <NuxtLink to="/" class="footer-link">{{ $t('navigation.home') }}</NuxtLink>
            </li>
            <li>
              <NuxtLink to="/about" class="footer-link">{{ $t('navigation.about') }}</NuxtLink>
            </li>
            <li>
              <NuxtLink to="/activities" class="footer-link">{{ $t('navigation.activities') }}</NuxtLink>
            </li>
            <li>
              <NuxtLink to="/stores" class="footer-link">{{ $t('navigation.stores') }}</NuxtLink>
            </li>
          </ul>
        </div> -->

        <!-- Contact Info -->
        <div class="footer-section">
          <h3 class="footer-title">
            {{ $t('footer.contactInfo') }}
          </h3>
          <ul class="footer-links">
            <li class="contact-item">
              <svg class="contact-icon" viewBox="0 0 24 24" fill="currentColor">
                <path d="M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 0 0 2.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-.282.376-.769.542-1.21.38a12.035 12.035 0 0 1-7.143-7.143c-.162-.441.004-.928.38-1.21l1.293-.97c.363-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 0 0-1.091-.852H4.5A2.25 2.25 0 0 0 2.25 4.5v2.25z" />
              </svg>
              <span>{{ $t('footer.phone') }}</span>
            </li>
            <!-- <li class="contact-item">
              <svg class="contact-icon" viewBox="0 0 24 24" fill="currentColor">
                <path d="M1.5 8.67v8.58a3 3 0 0 0 3 3h15a3 3 0 0 0 3-3V8.67l-8.928 5.493a3 3 0 0 1-3.144 0L1.5 8.67z" />
                <path d="M22.5 6.908V6.75a3 3 0 0 0-3-3h-15a3 3 0 0 0-3 3v.158l9.714 5.978a1.5 1.5 0 0 0 1.572 0L22.5 6.908z" />
              </svg>
              <span>sanfubrand@163.com</span>
            </li> -->
            <li class="contact-item">
              <svg class="contact-icon" viewBox="0 0 24 24" fill="currentColor">
                <path fill-rule="evenodd" d="M11.54 22.351l.07.04.028.016a.76.76 0 0 0 .723 0l.028-.015.071-.041a16.975 16.975 0 0 0 1.144-.742 19.58 19.58 0 0 0 2.683-2.282c1.944-1.99 3.963-4.98 3.963-8.827a8.25 8.25 0 0 0-16.5 0c0 3.846 2.02 6.837 3.963 8.827a19.58 19.58 0 0 0 2.682 2.282 16.975 16.975 0 0 0 1.145.742zM12 13.5a3 3 0 1 0 0-6 3 3 0 0 0 0 6z" clip-rule="evenodd" />
              </svg>
              <span>{{ $t('footer.address') }}</span>
            </li>
          </ul>
        </div>

        <!-- Newsletter -->
        <div class="footer-section">
          <h3 class="footer-title">
            {{ $t('footer.newsletter') }}
          </h3>
          <div class="social-popover-container">
            <el-popover placement="top" :width="330" trigger="hover" popper-style="background: #999999d0; box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);display: flex;justify-content: center;align-items: center;flex-direction: column;gap: 10px; padding: 10px; border-radius: 10px; ">
              <template #reference>
                <div class="social-reference">
                  <img class="social-icon social-wechat" :alt="$t('footer.wechat.service')" src="https://www-img.sanfu.com/production/wechat1.jpg" />
                  <div class="social-text">{{ $t('footer.wechat.service') }}</div>
                </div>
              </template>
              <img src="https://www-img.sanfu.com/production/wechat1.jpg" :alt="$t('footer.wechat.service')" class="qr-code-image" />
              <div class="popover-text">{{ $t('footer.wechat.scanToFollow') }}</div>
            </el-popover>
            <el-popover placement="top" :width="330" trigger="hover" popper-class="social-popover" popper-style="background: #999999d0; box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);display: flex;justify-content: center;align-items: center;flex-direction: column;gap: 10px; padding: 10px; border-radius: 10px; ">
              <template #reference>
                <div class="social-reference">
                  <img class="social-icon social-wechat" :alt="$t('footer.wechat.subscription')" src="https://www-img.sanfu.com/production/wechat_subscribe.jpg" />
                  <div class="social-text">{{ $t('footer.wechat.subscription') }}</div>
                </div>
              </template>
              <img src="https://www-img.sanfu.com/production/wechat_subscribe.jpg" :alt="$t('footer.wechat.subscription')" class="qr-code-image" />
              <div class="popover-text">{{ $t('footer.wechat.scanToSubscribe') }}</div>
            </el-popover>
            <el-popover placement="top" :width="330" trigger="hover" popper-style="background: #999999d0; box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);display: flex;justify-content: center;align-items: center;flex-direction: column;gap: 10px; padding: 10px; border-radius: 10px; ">
              <template #reference>
                <div class="social-reference">
                  <img class="social-icon social-wechat" :alt="$t('footer.wechat.videoChannel')" src="https://www-img.sanfu.com/production/wechat_sph.jpg" />
                  <div class="social-text">{{ $t('footer.wechat.videoChannel') }}</div>
                </div>
              </template>
              <img src="https://www-img.sanfu.com/production/wechat_sph.jpg" :alt="$t('footer.wechat.videoChannel')" class="qr-code-image" />
              <div class="popover-text">{{ $t('footer.wechat.scanVideoChannel') }}</div>
            </el-popover>
          </div>
        </div>
      </div>

      <!-- Footer Bottom -->
      <div class="footer-bottom">
        <div class="footer-bottom-content">
          <div class="copyright-section">
            <p class="copyright">© 2025 {{ $t('footer.copyright') }}</p>
            <!-- 备案信息 -->
            <div class="record-info">
              <p class="icp-record">
                <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer">{{ $t('footer.icpRecord') }}</a>
              </p>
              <!-- <p class="police-record">
                <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31010102003108" target="_blank" rel="noopener noreferrer">
                  <svg class="police-icon" viewBox="0 0 20 20" fill="currentColor">
                    <path d="M10 2L3 7v11h14V7l-7-5zM8 16H6v-4h2v4zm4 0h-2v-4h2v4zm2-6H6V8h8v2z"/>
                  </svg>
                  {{ currentLang === 'zh' ? '沪公网安备 31010102003108号' : currentLang === 'en' ? '沪公网安备 31010102003108号' : '沪公网安备 31010102003108号' }}
                </a>
              </p> -->
            </div>
          </div>
          <div class="footer-bottom-links">
            <NuxtLink to="/disclaimer" class="footer-bottom-link">{{ $t('footer.disclaimer') }}</NuxtLink>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script setup>
  const subscribe = () => {
    // 处理订阅逻辑
    console.log('Newsletter subscription')
  }
</script>

<style scoped>
  .footer {
    background-color: #1d0f0c;
    color: var(--white);
    padding-top: var(--space-16);
    padding-bottom: var(--space-8);
  }

  .container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 var(--space-24);
  }

  .footer-content {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: var(--space-10);
    margin-bottom: var(--space-12);
  }

  .footer-section {
    display: flex;
    flex-direction: column;
    max-width: calc(33% - var(--space-10));
    min-width: 300px;
  }

  /* Footer Logo */
  .footer-logo {
    display: flex;
    align-items: center;
    gap: var(--space-3);
    margin-bottom: var(--space-4);
  }

  .logo-icon {
    width: 145px;
    height: 28px;
    border-radius: var(--radius-lg);
    display: flex;
    align-items: center;
    justify-content: center;

    user-select: none;
    pointer-events: none;
    -webkit-user-drag: none;
  }

  .footer-description {
    color: var(--gray-300);
    line-height: 1.6;
    margin-bottom: var(--space-6);
    cursor: default;
  }

  /* Social Links */
  .social-links {
    display: grid;
    grid-template-columns: repeat(4, 40px);
    gap: var(--space-4);
  }

  .social-link {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    background-color: var(--gray-800);
    border-radius: var(--radius-full);
    color: var(--gray-300);
    transition: all var(--transition-fast);
    overflow: hidden;
    border: 4px solid var(--gray-800);
  }

  .social-link:hover {
    color: var(--white);
    transform: translateY(-2px);
  }

  .social-icon {
    width: 100%;
    height: 100%;
  }

  /* Footer Sections */
  .footer-title {
    font-size: var(--text-lg);
    font-weight: 600;
    margin-bottom: var(--space-4);
    color: var(--white);
  }

  .footer-links {
    flex: 1;
    list-style: none;
    padding-top: 10px;
    margin: 0;
  }

  .footer-links li {
    margin-bottom: var(--space-3);
  }

  .footer-link {
    color: var(--gray-300);
    transition: color var(--transition-fast);
  }

  .footer-link:hover {
    color: var(--primary);
  }

  /* Contact Items */
  .contact-item {
    display: flex;
    align-items: center;
    gap: var(--space-3);
    color: var(--gray-300);
    word-break: break-word;
  }

  .contact-icon {
    width: 16px;
    height: 16px;
    flex-shrink: 0;
    color: var(--primary);
  }

  /* Newsletter */
  .newsletter-description {
    color: var(--gray-300);
    margin-bottom: var(--space-4);
    line-height: 1.5;
  }

  .social-popover-container {
    display: flex;
    justify-content: flex-start;
    gap: 10px;
    padding-top: 16px;
  }

  .social-reference {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
  }

  .social-wechat {
    width: 90px;
    height: 90px;
  }

  .qr-code-image {
    width: 300px;
  }

  .social-text,
  .popover-text {
    font-size: 16px;
    color: #fff;
    text-align: center;
  }

  .newsletter-form {
    display: flex;
    gap: var(--space-2);
  }

  .newsletter-input {
    flex: 1;
    padding: var(--space-3);
    border: 1px solid var(--gray-700);
    border-radius: var(--radius);
    background-color: var(--gray-800);
    color: var(--white);
    font-size: var(--text-sm);
  }

  .newsletter-input::placeholder {
    color: var(--gray-400);
  }

  .newsletter-input:focus {
    outline: none;
    border-color: var(--primary);
    box-shadow: 0 0 0 3px rgba(230, 0, 18, 0.1);
  }

  .newsletter-btn {
    padding: var(--space-3) var(--space-4);
    background-color: var(--primary);
    color: var(--white);
    border: none;
    border-radius: var(--radius);
    font-weight: 500;
    font-size: var(--text-sm);
    cursor: pointer;
    transition: background-color var(--transition-fast);
    white-space: nowrap;
  }

  .newsletter-btn:hover {
    background-color: var(--primary-dark);
  }

  /* Footer Bottom */
  .footer-bottom {
    border-top: 1px solid var(--gray-800);
    padding-top: var(--space-8);
  }

  .footer-bottom-content {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    flex-wrap: wrap;
    gap: var(--space-4);
  }

  .copyright-section {
    display: flex;
    flex-direction: column;
    gap: var(--space-2);
  }

  .copyright {
    color: var(--gray-400);
    font-size: var(--text-sm);
    margin: 0;
  }

  /* 备案信息样式 */
  .record-info {
    display: flex;
    flex-direction: column;
    gap: var(--space-1);
  }

  .icp-record,
  .police-record {
    margin: 0;
    font-size: var(--text-xs);
  }

  .icp-record a,
  .police-record a {
    color: var(--gray-500);
    text-decoration: none;
    transition: color var(--transition-fast);
    display: flex;
    align-items: center;
    gap: var(--space-1);
  }

  .icp-record a:hover,
  .police-record a:hover {
    color: var(--gray-300);
  }

  .police-icon {
    width: 14px;
    height: 14px;
    flex-shrink: 0;
  }

  .footer-bottom-links {
    display: flex;
    gap: var(--space-6);
  }

  .footer-bottom-link {
    color: var(--gray-400);
    font-size: var(--text-sm);
    transition: color var(--transition-fast);
  }

  .footer-bottom-link:hover {
    color: var(--primary);
  }

  /* Responsive Design */
  @media (max-width: 768px) {
    .footer-content {
      gap: var(--space-20);
      justify-content: center;
    }

    .footer-section {
      align-items: center;
    }

    .footer-bottom-content {
      flex-direction: column;
      text-align: center;
      align-items: center;
    }

    .copyright-section {
      align-items: center;
      text-align: center;
    }

    .footer-bottom-links {
      justify-content: center;
    }

    .newsletter-form {
      flex-direction: column;
    }

    .newsletter-btn {
      align-self: stretch;
    }
  }
  @media (max-width: 600px) {
    .footer-content {
      gap: var(--space-12);
    }
  }

  @media (max-width: 480px) {
    .container {
      padding: 0 var(--space-3);
    }

    .footer-content {
      gap: var(--space-12);
    }

    .footer {
      padding-top: var(--space-12);
    }

    .social-links {
      justify-content: center;
    }

    .footer-bottom-links {
      flex-direction: column;
      gap: var(--space-3);
    }
  }
</style>
